export type intervalType = '1h' | '1d' | '7d' | '30d' | '365d' | 'ytd';

const getStartEndDate = (interval = '1d', unix: boolean = false) => {
	const duration = {
		'1h': 3600000,
		'1d': 86400000,
		'7d': 604800000,
		'30d': 2628000000,
		'365d': 31536000000,
		ytd: 15768000000,
	};

	const end = Date.now();

	if (unix) {
		return {
			start: Math.round(new Date(end - duration[interval]).getTime() / 1000),
			end: Math.round(new Date(end).getTime() / 1000),
		};
	} else {
		return {
			start: new Date(end - duration[interval]).toISOString(),
			end: new Date(end).toISOString(),
		};
	}
};

export default getStartEndDate;
